// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:146a80c7-a0b3-4604-bf2d-dfcdd01cfded",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_qLHZFMhz2",
    "aws_user_pools_web_client_id": "b1hv7hak8r9o2ns9qhmqg8f1j",
    "oauth": {},
    "aws_content_delivery_bucket": "awsapp-20190413004538-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://awsapp-20190413004538-hostingbucket-dev.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
